export enum MasterAgentDashboardCategory {
  All = 'all',
  Players = 'players',
  Agents = 'agents',
}
